import React from "react";
import PropTypes from "prop-types";
import ReactVideoPlayerPosts from "src/components/ReactPlayers/ReactVideoPlayerPosts";
import GrDialog from "src/design-system/components/GrDialog";
import { gr } from "src/design-system/tokens";
import FeedDetailBody, { feedHasMedia } from "./FeedDetailBody";

// Post popup (opened from a post's text, photo or "View more comments" on the community feed and the
// dashboard). The post itself is FeedDetailBody, shared with the post page.

export default function FeedDetailPopup({
  post_id,
  feed,
  getFeedsListingOnAddFeed,
  handleSuccessDelete,
  handleSuccessUpdate,
  selectedImageIndex,
}) {
  return (
    <FeedDetailBody
      key={post_id}
      postId={post_id}
      initialFeed={feed}
      layout="popup"
      selectedImageIndex={selectedImageIndex}
      VideoPlayer={ReactVideoPlayerPosts}
      onFeedChange={getFeedsListingOnAddFeed}
      onDeleted={handleSuccessDelete}
      onUpdated={handleSuccessUpdate}
      focusComposerOnComment
    />
  );
}

FeedDetailPopup.propTypes = {
  post_id: PropTypes.string.isRequired,
  feed: PropTypes.object.isRequired,
  getFeedsListingOnAddFeed: PropTypes.func.isRequired,
  handleSuccessDelete: PropTypes.func.isRequired,
  handleSuccessUpdate: PropTypes.func.isRequired,
  selectedImageIndex: PropTypes.number,
};

// The popup with its dialog: ghost × (aria-label "Close"), Esc and the backdrop close it.
// A post with photos / video opens over the whole window (media on a dark pane, the post and comments
// beside it), as photo viewers do; a text post opens as a feed-wide dialog (full-screen on phones).
export function FeedDetailDialog({ open, onClose, ...popupProps }) {
  const hasMedia = feedHasMedia(popupProps.feed);
  return (
    <GrDialog
      open={open}
      onClose={onClose}
      showClose
      variant="media"
      fullScreen={hasMedia}
      maxWidth={gr.layout.feed}
    >
      {/* Nothing to show until a post is chosen (the dialog stays mounted, closed, on the page). */}
      {popupProps.post_id ? <FeedDetailPopup {...popupProps} /> : null}
    </GrDialog>
  );
}

FeedDetailDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
};
